export function isAudioOnlyStreamUrl(url: string) {
    const parts = url.split('.')
    return parts[parts.length - 2] === 'ao'
}
